// @ts-nocheck
/* eslint-enable */
import browserUtils from 'app/client/utils/browserUtils';
import { getPis } from 'app/client/utils/browserCookieUtils';
import { adapt_reduxToJava } from 'app/shared/flux/actions/FilterActions/adapters';
import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import last from 'lodash/last';
import uniq from 'lodash/uniq';

const LISTING_DICT = {
  auction: 'Buy_Auction',
  foreclosure: 'Buy_Foreclosure',
  land: 'Buy_Land',
  newHome: 'Buy_New_Home',
  corporate: 'Rent_Corporate',
  rental: 'Rent_Rental',
  room: 'Rent_Roommate',
  sublet: 'Rent_Sublet',
};

export const _getAdvertisementListingUrls = (listingTypes) => {
  if (listingTypes.length > 1 || isEmpty(listingTypes)) {
    return 'Rent_General';
  } else {
    return LISTING_DICT[listingTypes[0]];
  }
};
export const _getAdvertisementPlacements = (listingTypes) => {
  let adUnit = 'HotPads';
  const device = browserUtils.getDevice();

  if (device.screenWidth === 'sm' || device.screenWidth === 'xs') {
    adUnit = 'hotpads_phone_mweb';
  } else if (device.screenWidth === 'md') {
    adUnit = 'hotpads_tablet_mweb';
  }

  const baseUrl = `${adUnit}/Search_Results`;
  const listingUrl = listingTypes ? _getAdvertisementListingUrls(listingTypes) : 'Rent_General';

  return `${baseUrl}/${listingUrl}`;
};

const _getParsedString = (str = '') => str.toLowerCase().split(' ').join('_');
const _getPrange = (lowPrice = 0, highPrice = Number.POSITIVE_INFINITY) => {
  const rentalBuckets = [
    [0, 499],
    [500, 749],
    [750, 999],
    [1000, 1249],
    [1250, 1499],
    [1500, 1749],
    [1750, 1999],
    [2000, 2499],
    [2500, 2999],
    [3000, 3499],
    [3500, 3999],
    [4000, 4499],
    [4500, 4999],
    [5000, 5999],
    [6000, 6999],
    [7000, 7999],
    [8000, 8999],
    [9000, 9999],
  ];
  const selectedBuckets = [];

  rentalBuckets.forEach((bucket) => {
    const bucketMin = bucket[0];
    const bucketMax = bucket[1];

    if (lowPrice <= bucketMax && highPrice >= bucketMin) {
      selectedBuckets.push(bucket.join('-'));
    }
  });

  if (highPrice > last(rentalBuckets)[1]) {
    selectedBuckets.push('10000_and_up');
  }

  return flatten(selectedBuckets).join(',');
};
const _getListtp = (listingTypes) => {
  if (listingTypes.length > 1 || isEmpty(listingTypes)) {
    return 'Rent_General';
  } else {
    return LISTING_DICT[listingTypes[0]];
  }
};
const _removeFractionalValues = (arr = []) => {
  return arr.filter((v) => {
    if (!includes(v, '.5')) {
      return v;
    }
  });
};
const _getTargetingForNavAd = ({
  city = '',
  state,
  zip,
  latitude,
  longitude,
  beds,
  baths,
  lowPrice,
  highPrice,
  listingTypes,
  pis,
}) => {
  return {
    city: [_getParsedString(city)],
    state: [state],
    zip,
    prange: _getPrange(lowPrice, highPrice),
    bd: _removeFractionalValues(beds),
    listtp: _getListtp(listingTypes),
    ba: baths,
    latitude,
    longitude,
    pis,
  };
};

export const getAdvertisementConfigurationsHelper = (filter) => {
  const adaptedFilter = adapt_reduxToJava({ filter });
  const listingTypes = adaptedFilter.listingTypes.split(',');
  return [
    {
      name: 'srpAdSlot1',
      index: 4,
      placement: _getAdvertisementPlacements(listingTypes),
      format: 'search_1',
      sizes: [[1, 1], [805, 115], 'fluid'],
      type: 'srpAdSlot1',
    },
    {
      name: 'srpAdSlot2',
      index: 5,
      placement: _getAdvertisementPlacements(),
      format: 'search_2',
      sizes: [[1, 1], [805, 115], 'fluid'],
      type: 'srpAdSlot2',
    },
  ];
};

export const getAdvertisementSlotIdsHelper = (configurations) => {
  const ids = [];
  configurations.forEach((config) => {
    ids.push(`div-gpt-ad-${config.placement}-${config.index}-${config.type}`);
  });
  return ids;
};

export const getReduxAdSlotHelper = (options = {}) => {
  const { adConfigs, ads = {} } = options;

  return adConfigs.map((config) => {
    const adType = config.type;

    if (adType && ads[adType].id) {
      return ads[adType].slot;
    }

    return false;
  });
};

export const getStateForAdvertisementHelper = (isMapBorderActive, reduxAreaState, apiAreaState = 'ny') => {
  // For the state of Oregon only, use `ore` instead of `or`
  const formattedReduxAreaState = reduxAreaState === 'or' ? 'ore' : reduxAreaState;

  /**
   * Use state found in area reducer if the map has a definend boundary AND areaState is truthy
   * else, fall back on the adTags fetched state
   */

  return isMapBorderActive && reduxAreaState ? formattedReduxAreaState : apiAreaState;
};

export const getTargeting = (options = {}) => {
  const { defaultFilter = {}, filter = {}, area = {}, searchListings } = options;
  const pis = getPis();
  const adaptedFilter = adapt_reduxToJava({ filter });
  const listingTypes = adaptedFilter.listingTypes.split(',');

  const targetingObj = {
    city: area.area.city,
    state: area.area.state,
    listingTypes,
    pis,
  };

  if (area?.area?.coordinates?.lat) {
    targetingObj.latitude = Number(area.area.coordinates.lat);
    targetingObj.longitude = Number(area.area.coordinates.lon);
  }

  if (!isEqual(defaultFilter.bedrooms, filter.bedrooms)) {
    const bedrooms = adaptedFilter.bedrooms.split(',');
    targetingObj.beds = bedrooms;
  }
  if (!isEqual(defaultFilter.bathrooms, filter.bathrooms)) {
    const bathrooms = adaptedFilter.bathrooms.split(',');
    targetingObj.baths = bathrooms;
  }
  if (!isEqual(defaultFilter.price.min, filter.price.min)) {
    targetingObj.lowPrice = filter.price.min;
  }
  if (!isEqual(defaultFilter.price.max, filter.price.max)) {
    targetingObj.highPrice = filter.price.max;
  }

  targetingObj.zip = uniq(
    compact(
      searchListings.slice(0, 5).map((listing) => {
        return listing.address.zip;
      }),
    ),
  );

  return _getTargetingForNavAd(targetingObj);
};

export const isAdBlockedOrEmpty = (id) => {
  if (typeof window === 'undefined') {
    return false;
  }

  const adElement = document.getElementById(id);
  const adEmpty = !adElement || adElement.innerHTML === '' || adElement.firstChild?.innerHTML === '';

  if (adEmpty) {
    return true;
  }

  return false;
};
